<template>
    <div id="new-messenger-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper d-none">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-form-item
                        :validate-status="getErrorStatus('channelName')"
                        :help="getErrorMessage('channelName')"
                    >
                        <a-input
                            v-model="form.channelName"
                            :placeholder="$t('whatsappChannel.channelName')"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>

                <strong> {{ $t("message.messengerAddDesc") }} </strong>
                <div>
                    <a-checkbox :checked="termOfService" @change="acceptTermOfService('pp')"></a-checkbox>
                    <b
                        >{{ $t("search.integration.readAndAgree") }}
                        <a @click="acceptTermOfService('pp')">{{ $t("search.integration.privatePolicy") }}</a>
                        {{ $t("message.and") }}
                        <a @click="acceptTermOfService('tac')">{{ $t("search.integration.termsAndCondition") }}</a></b
                    >
                </div>
                <TermOfService
                    v-if="termOfServiceModal"
                    :type="termOfServiceModal"
                    @agree="acceptedTermOfService"
                    @cancel="termOfServiceModal = null"
                />

                <MessengerPageSelector
                    :pages="callbackResponse.pages"
                    v-model="selectedPage"
                    v-if="callbackResponse.accessToken"
                />
                <SupsisButton primary @click="handleSubmit" :disabled="!termOfService" v-else>
                    {{ $t("messenger.connectMessenger") }}
                </SupsisButton>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">{{ $t("message.cancel") }}</a-button>
                <a-button
                    class="pr-confirm-btn"
                    @click="handleSubmit"
                    type="primary"
                    :disabled="!termOfService || loading"
                >
                    {{ $t("mail.connect") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import CONFIG from "../../../../config/config";
import { copyText2Clipboard } from "../../../../utils/utils";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import { first, map, timeout } from "rxjs/operators";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import MessengerPageSelector from "./MessengerPageSelector.vue";
import TermOfService from "../../../../components/TermOfService.vue";
import { generateRandomId } from "../../../../utils/session";

export default {
    name: "CreateMessengerChannel",
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        TermOfService,
        MessengerPageSelector,
        SupsisButton,
    },
    data() {
        return {
            form: {
                channelName: "Messenger",
            },
            loading: false,
            clone: _.cloneDeep(this.channel),
            submitClicked: false,
            callbackResponse: {
                accessToken: null,
                pages: [],
            },
            selectedPage: null,
            termOfService: false,
            termOfServiceModal: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site?._id,
            userId: (state) => state.auth.user?._id || state.auth.adminUser?._id,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        acceptTermOfService(type) {
            this.termOfServiceModal = type || "pp";
        },
        acceptedTermOfService() {
            this.termOfServiceModal = null;
            this.termOfService = true;
        },
        getRedirectURL() {
            return `${CONFIG.SOCKET_URL}/webhook/oauth2/facebook`;
        },
        copyWebhookAddress() {
            copyText2Clipboard(this.getRedirectURL());
            this.$message.success("Redirect URL  copied to clipboard");
        },
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        handleCancel() {
            this.$emit("cancel");
        },
        startOauth() {
            const FACEBOOK_APP_ID = "7174288719300175";
            this.loading = true;
            const redirectUrl = this.getRedirectURL();

            const scopes = [
                'public_profile',
                'instagram_basic',
                'instagram_manage_messages',
                'instagram_manage_comments',
                'pages_manage_metadata',
                'pages_manage_engagement',
                'pages_show_list',
                'pages_read_engagement',
                'pages_messaging',
                'business_management',
                'pages_read_user_content',
                "pages_manage_ads",//reklam  izinleri için eklendi
                "ads_management"//reklam  izinleri için eklendi
            ]
            const scope = scopes.join(",");
            const state = this.siteId + "_" + this.userId + "_messenger_" + generateRandomId(4);
            const url = `https://www.facebook.com/v19.0/dialog/oauth?client_id=${FACEBOOK_APP_ID}&redirect_uri=${redirectUrl}&state=${state}&scope=${scope}`;
            this.listenSocket();
            this.window = window.open(url, "_blank");
        },
        listenSocket() {
            socketMessageStream
                .pipe(
                    first((x) => x.cmd === "facebook_callback_response"),
                    map((x) => x.data),
                    timeout(60000 * 10)
                )
                .toPromise()
                .then(async (data) => {
                    this.loading = false;
                    this.window.close();
                    this.$message.success("Messenger connected successfully");
                    this.callbackResponse = data.tokenInfo;
                })
                .catch((err) => {
                    this.loading = false;
                    this.window.close();
                    this.$message.error("Failed to connect Messenger");
                });
        },
        completeCreateChannel(payload) {
            const data = {
                payload,
                type: "messenger",
                name: this.selectedPage.name,
            };
            return this.createChannel(data)
                .then((channel) => {
                    this.$message.success("Channel created successfully");
                    this.$emit("ok");
                    sendSocketMessage("meta subscribe-webhook", {
                        siteId: this.siteId,
                        channelId: channel._id,
                    });
                })
                .catch((err) => {
                    this.$message.error("Failed to create channel");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSubmit() {
            this.submitClicked = true;
            if (this.form.channelName.length < 1) {
                this.$refs.channelName.focus();
                return;
            } else {
                const isValid = true;
                if (isValid) {
                    this.startOauth();
                }
            }
        },
    },
    mounted() {},
    beforeDestroy() {},
    watch: {
        selectedPage: {
            handler: async function (page) {
                if (page) {
                    const payload = {
                        page,
                        type: "messenger",
                        id: page.id,
                        oauth: this.callbackResponse,
                    };
                    await this.completeCreateChannel(payload);
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
#new-messenger-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .webhook-info {
            display: flex;
            gap: 5px;
            justify-content: center;
            padding: 5px;
            overflow-wrap: anywhere;

            .anticon {
                &:hover {
                    color: var(--color-text-info-hover);
                }
            }
        }

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
            height: 75px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>

<style lang="scss">
.new-messenger-channel {
    .ant-modal {
        width: 520px !important;
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        margin: 0 24px;
    }

    .ant-modal:has(.small-modal) {
        width: 400px !important;
    }

    .ant-modal:has(.medium-modal) {
        width: 1000px !important;
        max-width: 1200px !important;
    }

    .ant-modal:has(.large-modal) {
        width: 1200px !important;
        max-width: 1400px !important;
    }

    .ant-modal-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ant-modal-content {
        height: auto !important;
    }

    .ant-modal-body {
        height: auto !important;
    }

    .custom-modal-body {
        padding: 0px !important;
        height: auto !important;
    }
}
</style>
